module.exports = __webpack_public_path__ + "img/scan-icon.12e656b6.svg";